import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PackageResponse } from "src/domain/client";
import { TranslateModule } from "@ngx-translate/core";
import { SubCategoryPackageComponent } from "../sub-category-package/sub-category-package.component";
import { CheckboxPackageComponent } from "../checkbox-package/checkbox-package.component";

@Component({
  selector: "app-additional-services",
  imports: [
    TranslateModule,
    SubCategoryPackageComponent,
    CheckboxPackageComponent
  ],
  templateUrl: "./additional-services.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdditionalServicesComponent {
  packages = input<PackageResponse[]>();
  parentForm = input<FormGroup<any>>();
}
